export default "__VITE_ASSET__e2000d71__"